import { useMutation } from '@tanstack/react-query';

import { fetchWithCsrfToken } from 'utils/fetchWrapper';

export interface DuplicateCompetencyVariables {
  interviewUid: string;
  competencyUid: string;
  includeQuestions: boolean;
}

interface DuplicateCompetencyResponse {
  uid: string;
}

const useDuplicateCompetency = () => {
  const {
    mutateAsync: duplicateCompetency,
    data,
    isLoading,
    error,
  } = useMutation<
    DuplicateCompetencyResponse,
    Error,
    DuplicateCompetencyVariables
  >(
    ['duplicateCompetency'],
    async ({ interviewUid, competencyUid, includeQuestions }) => {
      const body = {
        interview: interviewUid,
        competency: competencyUid,
        duplicate_with_questions: includeQuestions,
      };

      const response = await fetchWithCsrfToken<DuplicateCompetencyResponse>(
        'builder/async/competency/duplicate',
        'POST',
        body
      );

      return response;
    }
  );

  return {
    duplicateCompetency,
    data,
    isLoading,
    error,
  };
};

export default useDuplicateCompetency;
